import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  TopchartPageId,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { TOPCHARTS_COMMON_DOWNLOAD_API } from './common';

export default {
  [`${PC_CONSOLE_COMBINE_ENTITY_TYPE}-${TopchartPageId.PCConsoleMetricsTable}`]: {
    // apiUrl: '/api/v1/intelligence_pc/topChartPcConsoleMetricsBigQueryExcel',
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'sourceMetricSelectorNew',
        field: 'download_metrics',
        /**
         * combine端MetricsTable榜单页下载 级联指标筛选器默认值 是 页面的 级联指标筛选器勾选的指标作为默认值（宽表上方的级联指标筛选器）
         * 所以这里的defaultValue配置无用
         */
        defaultValue: [],
        options: [],
      },
      // V1208迭代融合ID下载添加发行商信息后端未排期
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          company_show: false,
          genre_show: false,
          release_date_show: false,
        },
        // isNeedMoreMarginTop: true,
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
          { label: 'dbi_release_date', value: 'release_date_show' },
          { label: 'dbi_steam_id', value: 'steam_id_show' },
          {
            label: 'dbi_metric_metacritic_global',
            value: 'meta_score_show',
            isNeedMoreMarginTop: true,
          },
          { label: 'dbi_top_steam_tags', value: 'steam_tag_show', isNeedMoreMarginTop: true },
          { label: 'dbi_top_game_mode', value: 'game_mode_show', isNeedMoreMarginTop: true },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_device_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'device_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_device_combine', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
};
